<template>
  <div class="modal-card" :props="{ isLogin }">
    <div class="modal-card-head">
      <div class="head">
        <h2>Ativar o seu cartão</h2>
        <p>
          Se você já recebeu seu cartão aproveite e ative ele agora mesmo. Seus
          resgates ficarão disponíveis em até 48 horas úteis.
        </p>
      </div>
    </div>

    <div class="modal-card-body">
      <div class="prompt">
        <app-input
          v-model="number"
          :maxlength="4"
          :placeholder="'Digite os 4 digitos finais do seu cartão'"
        ></app-input>
      </div>
    </div>

    <div class="modal-card-foot">
      <button @click="$parent.close()" v-app-button>
        {{ isLogin ? 'Não recebi o cartão' : 'Resgatar sem o cartão' }}
      </button>
      <button @click="activateCard()" v-app-button>Ativar meu cartão</button>
    </div>
  </div>
</template>

<script>
import ClientService from '@/services/client.service';

export default {
  name: 'app-modal',
  data: () => {
    return {
      number: null,
      isLogin: null,
    };
  },
  methods: {
    activateCard() {
      if (!this.number || this.number.length < 4) {
        this.toastify('Número inválido.', 'error');
        return;
      }

      this.isLoading = true;

      ClientService.activateCard(this.number)
        .then(() => {
          this.$parent.close();

          this.$buefy.dialog.alert({
            title: 'Cartão ativado!',
            message: 'Seu cartão foi ativado com sucesso!',
            confirmText: 'Legal!',
            type: 'is-success',
            icon: 'emoticon-excited',
            hasIcon: true,
          });
        })
        .catch(({ response }) => {
          const { status } = response;

          if (status === 400) {
            this.$buefy.dialog.alert({
              title: 'Número inválido!',
              message:
                'O número que você inseriu não bateu com os nossos registros. Em caso de dúvidas entre em contato com a gente no e-mail: atendimento@clubevendaeganhe.com.br',
              type: 'is-danger',
            });
          }
        })
        .finally(() => (this.isLoading = false));
    },
  },
  mounted() {
    this.isLogin = this.$parent.props.isLogin;
  },
};
</script>

<style lang="scss" scoped>
.modal-card {
  width: 500px;
  .modal-card-head {
    display: flex;
    flex-direction: column;

    h2 {
      font-size: 1.5em;
      margin-bottom: 10px;
    }
  }

  .modal-card-foot {
    display: flex;
    justify-content: flex-end;

    button {
      margin-left: 10px;
      border-radius: 8px;
    }

    button:first-child {
      background: var(--color-danger);
    }

    button:last-child {
      background: var(--color-success);
    }
  }
}
</style>
